export default {"src":"/_next/static/media/trendingStore.4244dd57.svg","height":178,"width":1440};